import type { ZoomChangeType } from '../../../../core/types/zoom.js';
import { isTimeAxis } from '../../../types/guards.js';
import type { XYChartAxisInternal } from '../../../types/xy-chart-internals.js';

export function handleZoomChange(
  axis: XYChartAxisInternal,
  min: number | Date,
  max: number | Date,
  zoomType: ZoomChangeType,
) {
  const timeAxis = isTimeAxis(axis);
  axis.onZoomChange(
    timeAxis ? new Date(min) : min,
    timeAxis ? new Date(max) : max,
    zoomType,
  );
}
